import type { CodeSystem, CodeSystemConcept } from '@medplum/fhirtypes';

const URL = 'https://liza.health/fhir/CodeSystem/mood-scale';

/** System for the Daily Mood Scale answer options (the 1–5 scale the patient picks from). The
 * scored ordinal (1–5) and Spanish display live on the Questionnaire answerOption, not here. */
export const MOOD_SCALE_SYSTEM = URL;

const CONCEPTS = [
  { code: 'very-bad', display: 'Very bad' },
  { code: 'bad', display: 'Bad' },
  { code: 'neutral', display: 'Neutral' },
  { code: 'good', display: 'Good' },
  { code: 'very-good', display: 'Very good' },
] as const satisfies CodeSystemConcept[];

export type MoodScaleCode = (typeof CONCEPTS)[number]['code'];

export const moodScaleCodeSystem: CodeSystem = {
  resourceType: 'CodeSystem',
  url: URL,
  name: 'mood-scale',
  title: 'Mood Scale',
  identifier: [{ system: 'urn:ietf:rfc:3986', value: URL }],
  status: 'active',
  content: 'complete',
  concept: CONCEPTS,
};
